var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atc-country"},[_c('div',{staticClass:"inner"},[_c('h2',{staticClass:"h3"},[_vm._v(_vm._s(_vm.location[0]))]),(_vm.location[1] !== '')?_c('h3',{staticClass:"h4"},[_vm._v(_vm._s(_vm.location[1]))]):_vm._e(),_c('hr'),_c('div',{staticClass:"flex"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }